import AddIcon from "../../../assets/svg/icono_agregar_blue.svg";

const BtnIncidentPayRoll = ({index,icon,label,functionName}:any) => {
   return (
    <button
        key={index}
        onClick={() => functionName()}          
        className="btnBits"
       >
        <div className="alineacionBoton">
        {icon ? <img src={AddIcon} alt={label}/>:"" }
          <div className="nombrePrestacion">
            <b><span>{label}</span> </b>
         </div>
        </div>
    </button> 
  )
}

export default BtnIncidentPayRoll
